import { useCallback, useState } from "react";
import { CashAndBankRepositoryImpl } from "../../data";
import {
  CashBankAccountEntity,
  GetCashBankAccountsUseCase,
} from "../../domain";

const repository = new CashAndBankRepositoryImpl();
const getCashBankAccountsUseCase = new GetCashBankAccountsUseCase(repository);

export const useCashBankAccounts = () => {
  const [accounts, setAccounts] = useState<CashBankAccountEntity[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAccounts = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await getCashBankAccountsUseCase.execute();
      setAccounts(result.accounts);
      return result.accounts;
    } catch (error: any) {
      setError(error.message || "Failed to load bank accounts");
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return {
    accounts,
    setAccounts,
    loading,
    error,
    fetchAccounts,
    clearError,
  };
};
